import script from "./Access.vue?vue&type=script&setup=true&lang=js"
export * from "./Access.vue?vue&type=script&setup=true&lang=js"

import "./Access.vue?vue&type=style&index=0&id=187c750a&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-187c750a"]])

export default __exports__